////COPIED FROM CONFLUENCE

import window from 'window-or-global';

// Stylesheet.
require('./charmap.css');

export default function confOfCharmap() {
	const plugger = () => {
		return {
			init: (ed) => {
				// Register commands
				ed.addCommand('confCharmap', () => {
					ed.windowManager.open({
						id: 'insert-char-dialog',
						url: `${window.tinymce.settings.editor_plugin_action_base_path}/charmap.action`,
						width: 600 + parseInt(ed.getLang('advanced.charmap_delta_width', 0)),
						height: 290 + parseInt(ed.getLang('advanced.charmap_delta_height', 0)),
						inline: true,
						name: 'advanced.charmap_desc',
					});
				});
			},

			getInfo: () => {
				return {
					longname: 'Confluence Charmap Plugin',
					author: 'Atlassian',
					authorurl: 'http://www.atlassian.com',
					version: `${window.tinymce.majorVersion}.${window.tinymce.minorVersion}`,
				};
			},
		};
	};

	window.tinymce.create('tinymce.plugins.ConfCharmapPlugin', plugger());

	// Register plugin
	window.tinymce.PluginManager.add('confcharmap', window.tinymce.plugins.ConfCharmapPlugin);
}
